<template>
    <welcome-box>
        <promo-notice />
        <login-form />
    </welcome-box>
</template>

<script>
import WelcomeBox from '@/components/WelcomeBoxOld.vue';
import LoginForm from '@/components/Login/LoginForm.vue';
import PromoNotice from '@/components/PromoNotice/PromoNotice.vue';

export default {
    components: {
        WelcomeBox,
        LoginForm,
        PromoNotice,
    },
};
</script>
